var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ver-mis-booking-por-aceptar',{staticClass:"mt-3",attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }